import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Table, Button, Space, Typography, Card, Modal, App } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

const { Title } = Typography;

const VideosAdmin = () => {
    const { message, modal } = App.useApp();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const pageSize = 20;

    const load = async (p = 1) => {
        setLoading(true);
        try {
            const res = await axios.get('/v1/videos', { params: { page: p, size: pageSize } });
            setItems(res.data?.data || []);
            setTotal(res.data?.pagination?.total || 0);
            setPage(res.data?.pagination?.page || p);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleDelete = async (video) => {
        modal.confirm({
            title: 'Delete Video',
            content: (
                <div>
                    <p>Are you sure you want to delete this video?</p>
                    <p><strong>{video.title}</strong></p>
                    <p style={{ color: '#ff4d4f', fontSize: '14px' }}>This action cannot be undone.</p>
                </div>
            ),
            okText: 'Delete',
            okType: 'danger',
            cancelText: 'Cancel',
            onOk: async () => {
                try {
                    await axios.delete(`/v1/videos/${video.id}`);
                    message.success('Video deleted successfully');
                    load(page); // Reload current page
                } catch (error) {
                    console.error('Delete error:', error);
                    message.error(`Failed to delete video: ${error.response?.data?.message || error.message}`);
                }
            },
        });
    };

    const columns = [
        {
            title: '',
            dataIndex: 'thumbnail_url',
            key: 'thumb',
            width: 70,
            fixed: 'left',
            render: (url, record) => (
                <div style={{ width: 50, height: 50, borderRadius: 6, overflow: 'hidden', background: '#f3f3f3' }}>
                    {url ? (
                        <img src={url} alt={record.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    ) : null}
                </div>
            ),
        },
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
            ellipsis: true,
            render: (text, record) => <Link to={`/videos/${record.slug}`}>{text}</Link>,
        },
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            responsive: ['md'],
        },
        {
            title: 'Language',
            dataIndex: 'language',
            key: 'language',
            width: 110,
            responsive: ['sm'],
        },
        {
            title: 'Visibility',
            dataIndex: 'visibility',
            key: 'visibility',
            width: 150,
            responsive: ['lg'],
        },
        {
            title: 'Actions',
            key: 'actions',
            fixed: 'right',
            width: 160,
            render: (_, record) => (
                <Space>
                    <Link to={`/admin/videos/${record.id}/edit?slug=${encodeURIComponent(record.slug)}`}>
                        <Button size="small" type="default">Edit</Button>
                    </Link>
                    <Button
                        size="small"
                        type="default"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => handleDelete(record)}
                        title="Delete video"
                    />
                </Space>
            ),
        },
    ];

    return (
        <div style={{ padding: 24 }}>
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
                <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                    <Title level={2} style={{ margin: 0 }}>Admin: Videos</Title>
                    <Link to="/admin/videos/new"><Button type="primary">+ New Video</Button></Link>
                </Space>
                <Card variant="outlined">
                    <style>{`
                        .videos-admin-table .ant-table { width: 100%; }
                        .videos-admin-table .ant-table-tbody > tr > td,
                        .videos-admin-table .ant-table-thead > tr > th { white-space: nowrap; }
                    `}</style>
                    <Table
                        className="videos-admin-table"
                        rowKey={(r) => r.id}
                        loading={loading}
                        columns={columns}
                        dataSource={items}
                        pagination={{ current: page, pageSize, total, onChange: (p) => load(p) }}
                        size="middle"
                        scroll={{ x: 700 }}
                        sticky
                    />
                </Card>
            </Space>
        </div>
    );
};

export default VideosAdmin;
